import { FormattedMessage, injectIntl } from 'react-intl';
import React from 'react';

const InjectMassage = (props) => <FormattedMessage {...props} />;

export default injectIntl(InjectMassage, {
  withRef: false,
});
